import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {NoticiaComponent} from "./noticia.component";
import {RouterModule} from "@angular/router";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";

@NgModule({
  imports: [
    CommonModule, RouterModule
  ],
  declarations: [NoticiaComponent],
  exports: [NoticiaComponent]
})
export class NoticiaModule { }



// WEBPACK FOOTER //
// ./src/app/pages/noticia/noticia.module.ts